module.exports = __webpack_public_path__ + "media/images/menu/telescopium-b25c11ae8ae644e119785343f553b68c.jpg";